<template>
    <div>   
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12">
                    <br>
                    <v-card > 
                        <mbs-page-tab 
                            :items="MY_LINKS"/> 
                        <mbs-item-manager
                            :row_click="true"
                            :add_vertical_lines="true"
                            :top_label="false"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="DATA.FIELDS.tills"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="TillsData"   
                            :is_joined="true"
                            :path_item="PATH_ITEM"  
                            :select_items="DataSource"  

                            :table_actions="table_actions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  

        <div>
            <v-dialog
                v-model="dialog_integrate_eis"
                scrollable   
                :persistent="true" :overlay="false"
                max-width="800px"
                transition="dialog-transition" >
                <v-card rounded="lg" class="b1 " >
                    <form @submit.prevent="ON_INTEGRATE_EIS(input)">
                        <!-- //------------TITLE -->
                        <v-card-title class="primary">
                            <div class="font-weight-bold b2--text">
                                INTEGRATE IES
                            </div> 
                            <v-spacer></v-spacer>
                            <v-btn class="ml-9" @click="dialog_integrate_eis=false" icon dark><v-icon >close</v-icon></v-btn>
                        </v-card-title> 
                        <v-card-text  class="pt-5 ">  
                            <mbs-input-fields class="ma-4"
                                v-model="input"
                                :name_items="NAME_ITEMS"
                                :name_item="NAME_ITEM"
                                :value_items="VALUE_ITEMS"
                                :field_items="DATA.FIELDS.eis_terminal"
                                :select_items="DataSource"
                                />
                        </v-card-text> 
                        <v-divider></v-divider> 
                        <v-card-actions>
                            <v-btn large class="px-8 mr-1" color="secondary">Cancel</v-btn>
                            <v-flex > 
                                <v-btn type="submit" :loading="inputLoading" large class="" width="100%" color="primary">Integrate</v-btn>
                            </v-flex>
                        </v-card-actions> 
                    </form>
                </v-card> 
            </v-dialog> 
        </div>
    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.TILLS.values    
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.TILLS.names,
                NAME_ITEM:DATA.ITEMS.TILLS.name,
                VALUE_ITEMS:DATA.ITEMS.TILLS.values,
                VALUE_ITEM:DATA.ITEMS.TILLS.value,  
     
                table_actions:[
                    {type:"btn",action:"add_item",color:"secondary", outlined:false,  text:"Add Till"},  
                ],
                DATA:DATA,
                dialog_integrate_eis:false,
                input:{},
                selected_till:null,
                inputLoading:false
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                }) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            },
             
            /////////
            selectedCompany(){  
                return this.$store.getters.getSelectedCompany
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("settings",1,true) 
                return thisLinks
            }, 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SelectedCompany: state=> state.items["SELECTED_COMPANY"],  
            }),
            ...mapState({
                Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
                JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()], 
                Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Devices: state=> state.items[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                JoinedDevices: state=> state.join[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                PrinterOptions: state=> state.app['PRINTER_OPTIONS'],
                TillTypes: state=> state.app['TILL_TYPES'],
                ServerTypes: state=> state.app[(DATA.ITEMS.SERVER_TYPES.values).toUpperCase()],
                ComputerTypes: state=> state.app[(DATA.ITEMS.COMPUTER_TYPES.values).toUpperCase()], 
                PricingTiers: state=> state.items[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
                JoinedPricingTiers: state=> state.join[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
                DefaultPricingTiers: state=> state.app['DEFAULT_PRICING_TIERS'], 
            }), 
            PricingTiersData(){
                return this.JoinedPricingTiers?this.JoinedPricingTiers:this.PricingTiers
            }, 
            AllPricingTiers(){
                let defaults = this.DefaultPricingTiers
                let tiers = this.PricingTiersData 
                let all = []
                if (defaults) {
                    all.push(...defaults)
                }if (tiers) {
                    tiers.forEach(tier => {
                        let index = all.findIndex(item=>item.key == tier.key)
                        if (index==-1) {
                            all.push(tier) 
                        } else {
                            all[index] = {
                                ...all[index],
                                ...tier
                            }
                        }
                    });
                }
                return all
            },
            PrinterDepartments(){
                const departments = this.ItemDepartments
                let all_departs = [
                    {key:'all',code:'all',name:"All"}
                ]
                if(!departments){return all_departs}
                all_departs.push(...departments)
                return all_departs
            },
            
            PATH_ITEM(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.tills,true) 
                return path
            }, 
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',icon:"mdi-cash-register",size:35,tile:true,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Outlet",value:"outlet_name",show:true},     
                    {id:0,name:"code",align:"center",show:true},     
                    {id:0,name:"Name",value:"name",show:true},     
                    {id:0,name:"Scanner(s)",value:"scanner_name",show:false},       
                    {id:0,name:"Printer(s)",value:"printer_names",show:true},       
                    {id:0,name:"Computer",value:"computer_name",show:true},       
                    {id:0,name:"Server",value:"server_name",show:true},     
                    {id:0,name:"Display",value:"vfd_display_name",show:false},       
                    {id:0,name:"MRA (EIS)",value:(this_,data,index)=>{
                        if (data.eis_terminal) {
                            if (data.eis_terminal.remark) {
                               return data.eis_terminal.remark
                            }else if (data.eis_terminal.confirmation_status) {
                               return data.eis_terminal.confirmation_status
                            }   
                            return "Terminal not Confirmed" 
                        }
                        return "No EIS Terminal"
                    },show:true},       
                    {id:0,name:"create",value:'created_at',show:false},    
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"edit"}, 
                        {name:"Integrate EIS Terminal",action:"integrate_eis_terminal",icon:"mdi-plus-network",
                            show_if:item=>!item.eis_terminal}, 
                        {name:"Confirm EIS Terminal",action:"confirm_eis_terminal",icon:"mdi-plus-network",
                            show_if:item=>item.eis_terminal && (item.eis_terminal?.confirmation_status!="CONFIRMED")}, 
                        {name:"Sync Products",action:"sync_eis_products",icon:"mdi-database-sync",
                            show_if:item=>item.eis_terminal && (item.eis_terminal?.confirmation_status=="CONFIRMED")}, 
                        {name:"Get latest Configuration",action:"get_latest_configuration",icon:"mdi-cog-sync-outline",
                            show_if:item=>item.eis_terminal && (item.eis_terminal?.confirmation_status=="CONFIRMED")}, 
                        {name:"Archive "+this.NAME_ITEM,action:"archive_item",icon:"delete"},  
                    ]}, 
                ]
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            }, 
            DataSource(){ 
                let Outlets = this.Outlets 
                let Servers = this.Servers 
                let Computers = this.Computers 
                let Printers = this.Printers 
                let Scanners = this.Scanners 
                let CustomerDisplays = this.CustomerDisplays 
                let ItemDepartments = this.ItemDepartments 
                let PrinterDepartments = this.PrinterDepartments 
                let PrinterOptions = this.PrinterOptions 
                let PricingTiers = this.AllPricingTiers 
                let Tills = this.JoinedTills 
                let TillTypes = this.TillTypes 
                return{
                    Outlets: Outlets, 
                    Servers: Servers, 
                    Computers: Computers, 
                    Printers: Printers, 
                    Scanners: Scanners, 
                    CustomerDisplays: CustomerDisplays, 
                    ItemDepartments: ItemDepartments, 
                    PrinterDepartments: PrinterDepartments, 
                    PrinterOptions: PrinterOptions, 
                    PricingTiers: PricingTiers, 
                    Tills: Tills, 
                    TillTypes: TillTypes, 
                }
            },
            TillsData(){ 
                let Tills = this.Tills
                let JoinedTills = this.JoinedTills   
                return JoinedTills?JoinedTills:Tills
            },
            DeviceData(){ 
                let Devices = this.Devices
                let JoinedDevices = this.JoinedDevices  
                return JoinedDevices?JoinedDevices:Devices
            },
            Scanners(){
                let devices = this.DeviceData 
                if(!devices){return null}
                let scanners = devices.filter(item=>{
                    return this.MBS.actions.TEXT_UP(item.device_type)
                     == this.MBS.actions.TEXT_UP(DATA.ITEMS.SCANNERS.value)
                }) 
                return scanners
            },
            Printers(){
                let devices = this.DeviceData 
                if(!devices){return null}
                let printers = devices.filter(item=>{
                    return this.MBS.actions.TEXT_UP(item.device_type)
                     == this.MBS.actions.TEXT_UP(DATA.ITEMS.PRINTERS.value)
                }) 
                return printers
            },
            Computers(){
                let devices = this.DeviceData 
                if(!devices){return null}
                let printers = devices.filter(item=>{
                    return this.MBS.actions.TEXT_UP(item.device_type)
                     == this.MBS.actions.TEXT_UP(DATA.ITEMS.COMPUTERS.value)
                }) 
                return printers
            },
            Servers(){
                let devices = this.DeviceData 
                if(!devices){return null}
                let printers = devices.filter(item=>{
                    return this.MBS.actions.TEXT_UP(item.device_type)
                     == this.MBS.actions.TEXT_UP(DATA.ITEMS.SERVERS.value)
                }) 
                return printers
            },
            CustomerDisplays(){
                let devices = this.DeviceData 
                if(!devices){return null}
                let printers = devices.filter(item=>{
                    return this.MBS.actions.TEXT_UP(item.device_type)
                     == this.MBS.actions.TEXT_UP(DATA.ITEMS.CUSTOMER_DISPLAYS.value)
                }) 
                return printers
            },
               
        },
        methods: { 
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "order_stock") {
                        this.MBS.actions.go(fullPath+"/order")
                    }else if (action == "received_stock") {
                        this.MBS.actions.go(fullPath+"/receive")
                    }else if (action == "return_stock") {
                        this.MBS.actions.go(fullPath+"/return")
                    }else if (action == "transfer_stock") {
                        this.MBS.actions.go(fullPath+"/transfer")
                    } else if (action == "manage_customer_groups") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/office/people/customers/groups",true))
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 
            ITEM_ACTION(action,item,option){
                try {     
                    // console.log(action,'***************');
                    if (action == "on_row_clicked") {
                         
                    }else if (action == "integrate_eis_terminal") {
                        this.selected_till = item
                        this.dialog_integrate_eis = true
                    }else if (action == "confirm_eis_terminal") {
                        this.selected_till = item
                        this.ON_CONFIRM_EIS(item)
                    }else if (action == "get_latest_configuration") {
                        this.selected_till = item
                        this.ON_GET_LATEST_CONFIGURATION(item)
                    }else if (action == "sync_eis_products") {
                        this.selected_till = item
                        this.ON_SYNC_EIS_PRODUCTS(item)
                    }else{}
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ON_INTEGRATE_EIS(input){
                try {     
                    const till = this.selected_till
                    const data ={
                        till,
                        terminalActivationCode:input?.terminalActivationCode,
                        confirm_terminal:input?.confirm_terminal?input?.confirm_terminal:false,
                        description:input?.description?input?.description:null
                    }
                    console.log(data);
                    
                    let mbs_text = this.MBS.text.item_action("EIS Terminal","Integrate")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=INTEGRATE-EIS", 
                            data
                        } 
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_INTEGRATE_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            INTEGRATE_EIS(data){
                try {     
                    console.log(data,'iiiiiii');
                    let SelectedCompany = this.SelectedCompany           
                    let company_key = SelectedCompany?SelectedCompany.company_key:null 
                    const upload_data ={
                        path:"activate-terminal",
                        is_full_path:false,
                        data:{
                            company_key,
                            till_key:data?.till?.key,
                            terminalActivationCode:data.terminalActivationCode,
                            confirm_terminal:data.confirm_terminal,
                            environment: {
                                platform: {
                                    osName: "Windows 10",
                                    osVersion: "Windows 10",
                                    osBuild: "10.901.2",
                                    macAddress: "00-00-00-00-00-00"
                                },
                                pos: {
                                    productID: "MRA-desktop/{guid}",
                                    productVersion: "1.0.0"
                                }
                            }

                        }
                    }
                    console.log(upload_data,'upload_data-----------');
                    
                    this.inputLoading = true 
                    this.MBS.actions.progressDialog({
                        show:true,
                        fixed:false,
                        title:"Reloading.."
                    }) 
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............tt');
                        this.dialog_integrate_eis = false
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_success("Eis Terminal","Integrating")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        let error_res = error?.error?.body?.error
                        error_res = error_res?error_res:""
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail("Eis Terminal","Integrating")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+error_res+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INTEGRATE_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            ON_CONFIRM_EIS(){
                try {     
                    const till = this.selected_till
                    const data ={
                        till, 
                    }
                    console.log(data);
                    
                    let mbs_text = this.MBS.text.item_action("EIS Terminal","Confirm")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=CONFIRM-EIS", 
                            data
                        } 
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            CONFIRM_EIS(data){
                try {     
                    console.log(data,'iiiiiii');
                    let SelectedCompany = this.SelectedCompany           
                    let company_key = SelectedCompany?SelectedCompany.company_key:null 
                    const upload_data ={
                        path:"confirm-terminal",
                        is_full_path:false,
                        data:{
                            company_key,
                            till_key:data?.till?.key,  
                        }
                    }
                    console.log(upload_data,'upload_data-----------');
                    
                    this.inputLoading = true 
                    this.MBS.actions.progressDialog({
                        show:true,
                        fixed:false,
                        title:"Reloading.."
                    }) 
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............tt');
                        this.dialog_integrate_eis = false
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_success("Eis Terminal","Confirming")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        let error_res = error?.error?.body?.error
                        error_res = error_res?error_res:""
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail("Eis Terminal","Confirming")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+error_res+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            ON_GET_LATEST_CONFIGURATION(){
                try {     
                    const till = this.selected_till
                    const data ={
                        till, 
                    }
                    console.log(data);
                    
                    let mbs_text = this.MBS.text.item_action("Latest Configuration","Get")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=GET-LATEST-CONFIGURATION", 
                            data
                        } 
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            GET_LATEST_CONFIGURATION(data){
                try {     
                    console.log(data,'iiiiiii');
                    let SelectedCompany = this.SelectedCompany           
                    let company_key = SelectedCompany?SelectedCompany.company_key:null 
                    const upload_data ={
                        path:"refresh-config",
                        is_full_path:false,
                        data:{
                            company_key,
                            till_key:data?.till?.key,  
                        }
                    }
                    console.log(upload_data,'upload_data-----------');
                    
                    this.inputLoading = true 
                    this.MBS.actions.progressDialog({
                        show:true,
                        fixed:false,
                        title:"Reloading.."
                    }) 
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............tt');
                        this.dialog_integrate_eis = false
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_success("Latest Eis Configuration","Getting")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        let error_res = error?.error?.body?.error
                        error_res = error_res?error_res:""
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail("Latest Eis Configuration","Getting")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+error_res+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            ON_SYNC_EIS_PRODUCTS(){
                try {     
                    const till = this.selected_till
                    const data ={
                        till, 
                    }
                    console.log(data);
                    
                    let mbs_text = this.MBS.text.item_action("EIS Products","SYNC")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=SYNC-EIS-PRODUCTS", 
                            data
                        } 
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            SYNC_EIS_PRODUCTS(data){
                try {     
                    console.log(data,'iiiiiii');
                    let SelectedCompany = this.SelectedCompany           
                    let company_key = SelectedCompany?SelectedCompany.company_key:null 
                    const upload_data ={
                        path:"sync-mra-items-to-inventory",
                        is_full_path:false,
                        data:{
                            company_key,
                            till_key:data?.till?.key,  
                        }
                    }
                    console.log(upload_data,'upload_data-----------');
                    
                    this.inputLoading = true 
                    this.MBS.actions.progressDialog({
                        show:true,
                        fixed:false,
                        title:"Reloading.."
                    }) 
                    this.MBS.actions.POST_REQUEST(upload_data)
                    .then(res=>{
                        console.log(res,'res in............tt');
                        this.dialog_integrate_eis = false
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_success("Eis Terminal","Confirming")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'Err in............tt');
                        let error_res = error?.error?.body?.error
                        error_res = error_res?error_res:""
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail("Eis Terminal","Confirming")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text+" ("+error_res+")",
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    })
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_EIS',
                        page:PAGE_NAME, 
                    }) 
                } 
                
            },
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) { 
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, 100);  
                                }   
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=INTEGRATE-EIS') {
                            if (action.YES) {
                                setTimeout(() => {
                                    this.INTEGRATE_EIS(action.data)
                                }, 100);     
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=CONFIRM-EIS') {
                            if (action.YES) {
                                setTimeout(() => {
                                    this.CONFIRM_EIS(action.data)
                                }, 100);     
                            } else {
                                
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=GET-LATEST-CONFIGURATION') {
                            if (action.YES) {
                                setTimeout(() => {
                                    this.GET_LATEST_CONFIGURATION(action.data)
                                }, 100);     
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=SYNC-EIS-PRODUCTS') {
                            if (action.YES) {
                                setTimeout(() => {
                                    this.SYNC_EIS_PRODUCTS(action.data)
                                }, 100);     
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            
                             
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            }, 
    
        },
        beforeDestroy(){
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
        },
        watch: { 
            us:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
